import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { formatDate, DatePipe } from '@angular/common';
import * as moment from "moment";

@Injectable({
  providedIn: 'root'
})
export class GLOBALService {
  iduser = localStorage.getItem("userId");
  fecha_hoy= new Date;
  hoy;
  persona;
  result;
  horahoy = new Date;
  hora;

  constructor(private http: HttpClient,
              private datePipe: DatePipe){
  }

  saludo(){ //esto devuelve la palabra rial como string llamando en algun component.ts asi: this.global.saludo();
    this.persona = "rial";
    console.log("saludo a: " + this.persona);
    return this.persona;
  }

  horario(){
    this.hora = (this.horahoy.getHours() + ":" + this.horahoy.getMinutes());
    return this.hora;
  }

  historicalTo( accion:string, catego:string ){
    this.fecha_hoy = new Date;
    this.hoy = this.datePipe.transform(this.fecha_hoy,"yyyy-MM-dd");
    
    //http://localhost:1337/api/historico/add?iduser=35363906&observ=mentis&fecha=2019-01-09&cate=NO-DEFINE 
    this.http.get(`${environment.backendUrl}/api/historico/add?iduser=${this.iduser}&observ=${accion}&fecha=${this.hoy}&cate=${catego}`)
    .subscribe((data: any) => {
      this.result = JSON.stringify(data["affectedRows"]);
      if (this.result>0){
        console.log("GLOBAL-> **Accion añadida: user: " + this.iduser + ", accion: " + accion + " fecha: "+ this.hoy+" a las " + this.horario() + "**");
      }else{
        console.log(`**salio mal**`);
        return "**GLOBAL-> **salio mal**";
        //return res="fallo"
      }
    });
  }

  /*
  getRepo(){
    //http://localhost:1337/api/contador/repo?fdes=2018-01-01&fhas=2019-01-01
    this.http.get(`${environment.backendUrl}/api/contador/repo?fdes=${this.fecha_ticket}&fhas=${this.fecha_ticket2}`)
    .subscribe((datos: any[]) => {
      if (datos){
        console.log("fechas con datos!");
        this.dataSourceReporte.data = datos[0];
        console.warn(this.dataSourceReporte.data);
        this.exportAsExcelReporte();
        this.loading=false;
      }else{
        console.log("fechas sin datos..");
        this.loading=false;
      }
    });
  }
 
  */

  

}

